window.Popper = require("popper.js").default;
window.$ = window.jQuery = require("jquery");
require("../bootstrap/dist/js/bootstrap");

require("../plugins/modernizr-custom");

require("leaflet");
require("paroller.js");
require("@fancyapps/fancybox");
require("slick-carousel");
require("./sliders");
require("bootstrap");

require("./scripts");
require("./mapa");
// require("./privacidad");
require("./whatsapp");
require("./plugins/mapify/jquery.mapify");
require("slick-carousel");
require("./plugins/vide.min");

require("../menu");

require("../promo_webpay");
require("../components/banner_promocion_04_24");

import AOS from "aos";
import "aos/dist/aos.css";

$(document).ready(function () {
    console.log("enter");
    $("#loading").fadeOut();
});

/* $.whatsappButton({
    right: 20,
    bottom: 20,
    number: 56971596891,
    chatMode: true,
    profilePhoto: "./assets/images/avatar_wsp.jpg",
    iconButton: "./assets/images/whatsapp.png",
    sendMessageIcon: "./assets/images/flecha_wsp.png",
}); */

$(window).scroll(function () {
    let scrollTop = $(this).scrollTop();
    if ($("body").not(".scroll") && scrollTop >= 10) {
        $("body").addClass("scroll");
    } else $("body").removeClass("scroll");
});

$(".scroll-to").click(function (e) {
    e.preventDefault();
    const target_id = $(this).attr("href");
    const $toElement = $(target_id);
    if ($(window).width() < 768 && $(this).hasClass("nav-link")) {
        $(".navbar-toggler").click();
    }

    $([document.documentElement, document.body]).animate(
        {
            scrollTop: $toElement.offset().top,
        },
        1000
    );

    return false;
});

function onScroll(event) {
    var scrollPos = $(document).scrollTop();
    $("#navbarCollapse .nav-item a").each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (
            refElement.position().top - 100 <= scrollPos &&
            refElement.position().top + refElement.height() > scrollPos
        ) {
            $("#navbarCollapse .nav-item a").removeClass("active");
            currLink.addClass("active");
        } else {
            // currLink.removeClass("active");
        }
    });
}
$(document).on("scroll", onScroll);

$(".cotizar").on("click", function () {
    $(this)
        .parents(".datos-planta")
        .fadeOut(function () {
            $(this).siblings(".cotiza-planta").fadeIn();
        });
});
$(".ver-planta").on("click", function () {
    $(this)
        .parents(".cotiza-planta")
        .fadeOut(function () {
            $(this).siblings(".datos-planta").fadeIn();
        });
});

jQuery(document).ready(function ($) {
    $("#atributos-slider .slide")
        .slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            dots: false,
            prevArrow:
                '<a class="slick-arrow slick-arrow-prev" href="javascript:void(null);"><img src="../../images/notros-de-alicura/atributos/flecha_izquierda.png" /></a>',
            nextArrow:
                '<a class="slick-arrow slick-arrow-next" href="javascript:void(null);"><img src="../../images/notros-de-alicura/atributos/flecha_derecha.png" /></a>',
        })
        .on("beforeChange", function (event, slick, num) {
            $("#atributos-slider .slide-dot").removeClass("active");
            $("#atributos-slider .atributo-titulo").animate({ opacity: 0 });
        })
        .on("afterChange", function (event, slick, num) {
            const $current = $("#atributos-slider .slick-current");
            const $bro = $current.find(".item").data("bro");
            const title = $current.find(".item").data("title");
            $(`.${$bro}`).addClass("active");
            $("#atributos-slider .atributo-titulo")
                .text(title)
                .animate({ opacity: 1 });
        });

    function inicia_video() {
        $("#hero .texto").fadeIn(1000);
        setTimeout(() => {
            $("#hero .texto").fadeOut(1000);
        }, 1000);

        setTimeout(() => {
            $("#hero .logo").fadeIn(1200);
        }, 2000);

        setTimeout(() => {
            $("#hero .logo").fadeOut(1000);
        }, 6500);
    }

    setInterval(() => {
        inicia_video();
    }, 12750);
    inicia_video();
});

$("#atributos-slider .slide-dot").on("click", function (e) {
    const $bro = $(this).data("bro");
    $("#atributos-slider .slide").slick("slickGoTo", $bro);
});

$(document).ready(function () {
    setTimeout(() => {
        AOS.init();
    }, 2000);
});
